// A19.07 content-takedown-request tracking — module-local data layer. REAL
// backend (/admin/takedowns). Tracking only — removal is a deliberate action.
import { api } from '@/lib/api'

export interface Takedown {
  id: number
  content_type: string
  content_ref: string
  reason: string
  source: string
  complainant: string
  status: string
  resolution: string
  resolved_at: string | null
  created_at: string
}

export const fetchTakedowns = (status = '', s?: AbortSignal) =>
  api.get<{ takedowns: Takedown[] }>('/admin/takedowns', { query: status ? { status } : {}, ...(s ? { signal: s } : {}) }).then((d) => d.takedowns ?? [])
export const createTakedown = (body: {
  content_type: string
  content_ref: string
  reason: string
  source: string
  complainant: string
}) => api.post<{ id: number }>('/admin/takedowns', body)
export const updateStatus = (id: number, status: string, resolution: string) =>
  api.post(`/admin/takedowns/${id}/status`, { status, resolution })
export const deleteTakedown = (id: number) => api.del(`/admin/takedowns/${id}`)

export const CONTENT_TYPES = ['message', 'media', 'channel', 'group', 'user', 'other'] as const
export const SOURCES = [
  { key: 'dmca', label: 'DMCA' },
  { key: 'court', label: 'Суд' },
  { key: 'policy', label: 'Политика' },
  { key: 'user_report', label: 'Жалоба' },
  { key: 'law_enforcement', label: 'Правоохранит.' },
] as const
export const STATUSES = [
  { key: 'open', label: 'Открыт', pill: 'bg-warning/10 text-warning' },
  { key: 'reviewing', label: 'Рассмотрение', pill: 'bg-accent/10 text-accent' },
  { key: 'removed', label: 'Удалён', pill: 'bg-success/10 text-success' },
  { key: 'rejected', label: 'Отклонён', pill: 'bg-surface-3 text-tertiary' },
] as const

export function sourceLabel(s: string) {
  return SOURCES.find((x) => x.key === s)?.label ?? s
}
export function statusMeta(s: string) {
  return STATUSES.find((x) => x.key === s) ?? STATUSES[0]
}

export const TD_STR = {
  title: 'Запросы на удаление контента',
  desc: 'DMCA / суд / политика — учёт запросов и решение. Удаление — отдельное действие модерации',
  create: 'Новый запрос',
  contentType: 'Тип',
  contentRef: 'ID/URL контента',
  source: 'Источник',
  complainant: 'Заявитель',
  reason: 'Причина',
  add: 'Создать',
  reviewing: 'В рассмотрение',
  remove: 'Удалить контент',
  reject: 'Отклонить',
  delete: 'Удалить запись',
  done: 'Готово',
  failed: 'Ошибка',
  empty: 'Нет запросов',
  all: 'Все',
  content: 'Контент',
} as const
